import { EmailTemplate } from './types';

const mutations = {
  setEmailTemplates(state, emailTemplates: EmailTemplate[]) {
    state.emailTemplates = emailTemplates;
  },
  setLoadingEmailTemplatesList(state, loadingEmailTemplateList: boolean) {
    state.loadingEmailTemplateList = loadingEmailTemplateList;
  },
  setLoadingTemplateCreateUpdate(state, loadingTemplateCreateUpdate: boolean) {
    state.loadingTemplateCreateUpdate = loadingTemplateCreateUpdate;
  },
  setDeleteTemplateLoader(state, deleteTemplateLoader: boolean) {
    state.deleteTemplateLoader = deleteTemplateLoader;
  },
  setEmailTemplate(state, emailTemplate: EmailTemplate) {
    state.emailTemplates.forEach((element, index) => {
      if (element.id === emailTemplate.id) {
        state.emailTemplates[index] = emailTemplate;
      }
    });
    state.emailTemplates = [...state.emailTemplates];
  },
  addNewEmailTemplate(state, emailTemplate: EmailTemplate) {
    const tempArray = state.emailTemplates.slice(0);
    tempArray.push(emailTemplate);
    state.emailTemplates = tempArray;
  },
  removeTemplate(state, templateId: string) {
    let tempArray = state.emailTemplates.slice(0);
    tempArray = tempArray.filter(elm => elm.id !== templateId);
    state.emailTemplates = tempArray;
  },
  setBlankEmailTemplateJson(state, blankEmailTemplateJson: string) {
    state.blankEmailTemplateJson = blankEmailTemplateJson;
  },
  setEmailTemplatesFor(state, emailTemplatesFor: string) {
    state.emailTemplatesFor = emailTemplatesFor;
  }
};

export default mutations;
